import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { pillars, volumes, volumeIncludes } from '../data/volumes';
export function Volumes() {
  return <section aria-label="Contenu de la méthode" className="bg-transparent" data-id="element-184" data-mp="184f1q1waxg7h">
      <div className="mx-auto max-w-6xl px-5 py-12" style={{
      paddingTop: '19px',
      paddingBottom: "21px"
    }} data-id="element-185" data-mp="1822cd3o7s3ke">
        <div className="text-center" data-id="element-186" data-mp="1zv1jx1mdgpiq">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-grape" data-id="element-187" data-mp="1zw49n67yklx2">
            🏥 MÉTHODE REHAB 360™ : LE SYSTÈME VISUEL
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-188" data-mp="1qud88dkgb190">
            📚 La Méthode Clinique en 6 Volumes
          </h2>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-189" data-mp="1vs4zd5d9ujc5">
            {pillars.map(p => <span key={p} className="rounded-full border border-grape/25 bg-lilac-soft px-3 py-1 text-xs font-bold uppercase tracking-wide text-plum-soft" data-id="element-190" data-mp="fe6fnyynabnm">
                {p}
              </span>)}
          </div>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-191" data-mp="3o8oovqhol2oy">
          {volumes.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 3 * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="rounded-2xl border border-grape/15 bg-white p-5" style={{
          paddingTop: "10px",
          paddingBottom: "8px"
        }} data-id="element-192" data-mp="3jamyekhxe13g" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-193" data-mp="60pjiase9pwx">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-lilac-soft font-display text-lg font-black text-grape" data-id="element-194" data-mp="kq4xsraqo2vq">
                  {String(t.n).padStart(2, '0')}
                </span>
                <h3 className="text-sm font-bold leading-tight text-plum" data-id="element-195" data-mp="tq1rj7bzjrxn">
                  <span aria-hidden="true" data-id="element-196" data-mp="pru7o3m86ai8">{t.emoji} </span>
                  {t.title}
                </h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-plum/65" data-id="element-197" data-mp="wrmrlv7ud1of">{t.desc}</p>
            </motion.article>)}
        </div>

        <div className="mt-10 rounded-2xl border border-grape/25 bg-white p-6" data-id="element-198" data-mp="16s6vl5mqwkac">
          <p className="text-center font-display text-lg font-black text-grape" data-id="element-199" data-mp="16q2ibx2yi8xe">
            ✅ Chaque volume inclut :
          </p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-200" data-mp="1fkqn7m4mdolo">
            {volumeIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-plum/75" data-id="element-201" data-mp="1kisdos4dkq76">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-202" data-mp="1piobg9mhblea" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}